<idp-simple-modal
  (openChange)="closeModalHandler()"
  [closeOnBackgroundClick]="false"
  [height]="height"
  [open]="openModal"
  [showFooter]="false"
  class="idp-partner-modal"
  modalTitle
>
  <div class="idp-partner-modal__body" id="partnerModalBody">
    <form
      [action]="values.applyURL | safe: 'url'"
      [formGroup]="partnerDataForm"
      class="fabForm"
      id="partnerForm"
      method="post"
      target="partnerframe"
    ></form>
    <iframe
      class="fab-frame idp-dialog__content--fab-frame"
      name="partnerframe"
      title="credit card application"
    ></iframe>
    <input
      (focus)="setFocusOnCloseBtn()"
      [attr.aria-label]="''"
      class="focus-trap-txt"
      type="text"
    />
  </div>
</idp-simple-modal>
